import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from 'gu-ui-kit'
import DatePicker from 'components/DatePicker'
import styles from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/budget-editor.module.scss'
import { parse } from 'date-fns'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const Dates = ({ original, setStartDate, setEndDate }) => {
  const { t } = useTranslation()
  const { date_start, date_end, rowState } = original
  const breakpoints = useBreakpoint()

  return (
    <Grid gap={16} wrap={'nowrap'}>
      <DatePicker
        InputProps={{
          size: !breakpoints.md ? 's' : 'm',
        }}
        mode={'calendar'}
        minDate={new Date()}
        placeholder={
          'campaigns_editor::budget_editor.controls_panel.dates.date_start.placeholder'
        }
        value={parse(date_start, 'yyyy-MM-dd', new Date()) ?? null}
        onChange={(newVal) => setStartDate(original, newVal)}
        error={rowState?.errors?.date_start ?? null}
        helperText={rowState?.errors?.date_start}
        buttonClassName={styles['date-picker__button']}
        asButton={false}
        popoverConfig={{
          variant: 'popover',
          id: 'datePickerPopover',
          breakpoints: {
            0: {
              variant: 'bottomSheet',
              hasBackdrop: true,
              showLabel: true,
              label: t(
                'campaigns_editor::budget_editor.controls_panel.dates.date_start.placeholder',
              ),
            },
            768: {
              variant: 'popover',
              hasBackdrop: false,
            },
          },
        }}
      />

      <DatePicker
        InputProps={{
          size: !breakpoints.md ? 's' : 'm',
        }}
        mode={'calendar'}
        minDate={parse(date_start, 'yyyy-MM-dd', new Date())}
        label={
          date_end
            ? ''
            : 'campaigns_editor::budget_editor.controls_panel.dates.date_end.placeholder'
        }
        value={date_end ? parse(date_end, 'yyyy-MM-dd', new Date()) : null}
        onChange={(newVal) => setEndDate(original, newVal)}
        error={rowState?.errors?.date_end ?? null}
        helperText={rowState?.errors?.date_end}
        buttonClassName={styles['date-picker__button']}
        asButton={false}
        popoverConfig={{
          variant: 'popover',
          id: 'datePickerPopover',
          breakpoints: {
            0: {
              variant: 'bottomSheet',
              hasBackdrop: true,
              showLabel: true,
              label: t(
                'campaigns_editor::budget_editor.controls_panel.dates.date_end.placeholder',
              ),
            },
            768: {
              variant: 'popover',
              hasBackdrop: false,
            },
          },
        }}
      />
    </Grid>
  )
}

export default Dates

Dates.propTypes = {
  original: PropTypes.object,
  setStartDate: PropTypes.func,
  setEndDate: PropTypes.func,
}
